import * as React from "react"

import { cn } from "@/lib/utils"

/**
 * Kbd — indice de touche clavier réutilisable (HELP-DRAWER §9.2).
 *
 * Remplace les `<kbd>` HTML bruts dupliqués (footer du drawer, indices clavier).
 * Façon shadcn, zéro dépendance. Partagé avec SEARCH-002 (indice ⌘K + footer).
 */
const Kbd = React.forwardRef<HTMLElement, React.HTMLAttributes<HTMLElement>>(
  ({ className, ...props }, ref) => (
    <kbd
      ref={ref}
      className={cn(
        "inline-flex h-5 min-w-[1.25rem] select-none items-center justify-center gap-0.5",
        "rounded border border-border bg-muted px-1.5 font-mono text-[10px] font-medium",
        "leading-none text-muted-foreground",
        className,
      )}
      {...props}
    />
  ),
)
Kbd.displayName = "Kbd"

export { Kbd }
